import { render, staticRenderFns } from "./ProcessarFolhaPagamento.vue?vue&type=template&id=15d4a2d2&scoped=true&"
import script from "./ProcessarFolhaPagamento.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProcessarFolhaPagamento.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d4a2d2",
  null
  
)

export default component.exports